import Cookies from "js-cookie";
import { encrypt_cookie } from "./allfunction";
import * as XLSX from "xlsx";

import store from "../app/store";
import { setUser } from "../app/features/user/userSlice";
import moment from "moment";
import text from "../text.json";
import { formatFloatNumber } from "../App";
let ip = process.env.REACT_APP_IP;
let datefomat = "YYYY-MM-DD";
// const { user, name, log, level, user_id, retoken, token } =
//   store.getState().user;

function updatelogindata(data) {
  try {
    //   console.log(data);
    console.log("updatelogindata");
    if (data.user_id == "") {
      throw new Error(data);
    }
    store.dispatch(setUser(data));
  } catch (error) {
    console.log(error);
  }
}

export async function getDataPost_2(link, dataSetForGet, token, retoken) {
  try {
    let data = await getDataWithToken(link, dataSetForGet, token, retoken);
    return data.data;
  } catch (error) {
    return null;
  }
}

export async function getPDF_2(link, dataSetForGet, token, retoken) {
  try {
    let data = await getPDFWithToken(link, dataSetForGet, token, retoken);
    return data;
  } catch (error) {
    return null;
  }
}

// Cookies.set('log', encrypt_cookie(JSON.stringify(data)), { expires: 1 / 12 })
// dispatch(setUser(data))

async function getDataWithToken(url, dataSetForGet, token, retoken) {
  const {
    user,
    name,
    log,
    level,
    user_id,
    agent_id,
    agent_Code,
    agent_c,
    agent_unlock_a,
    agent_scp_p,
    agent_conf,
  } = store.getState().user;
  //let token =    "0eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NiwidXNlciI6InZ0MDAyIiwibGV2ZWwiOiJtYW5hZ2VyIiwiaWF0IjoxNzExNjg1NTMzLCJleHAiOjE3MTE2ODc2MzN9.ivY7aTYjmv9fBnBss-LTNjJ-JTUZu39Q0PSOKTw8yNw";
  // console.log(token);
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Authorization", `Bearer ${token}`);
  const raw = JSON.stringify(dataSetForGet);
  const requestOptions = {
    method: "POST",
    headers: headers,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    // console.log("Use old Token");
    if (response.status === 401) {
      // Token expired, get new token
      const refreshTokenResponse = await fetchRefreshToken(retoken);
      // console.log(refreshTokenResponse);
      // console.log(" old Token out");
      if (refreshTokenResponse.data.status !== 200) {
        alert("*ໂທກເຄັນທ່ານໝົ້ດອາຍຸ ກະລຸນາເຂົ້າສູ່ລະບົບໃໝ່*");

        // Get the current URL
        var currentURL = window.location.href;
        // Split the URL by "saleOnline/"
        var parts = currentURL.split("saleOnline");
        console.log(parts);
        // Extract the part after "saleOnline/"
        var extractedData = parts[0] + "saleOnline/Login";
        console.log(extractedData);
        // ລີໄດເລັກໄປໜ້າລ໊ອກອິນ
        window.location.assign(extractedData);
        // window.location.reload();
        return null;
      }
      const newToken = refreshTokenResponse.data.token;
      console.log("ອັບເດດຂໍ້ມູນເຂົ້າສູ່ລະບົບໃໝ່ NewToken");

      let data = {
        user,
        name,
        log,
        level,
        user_id,
        retoken: refreshTokenResponse.data.retoken,
        token: refreshTokenResponse.data.token,

        agent_id,
        agent_Code,

        agent_c,
        agent_unlock_a,
        agent_scp_p,
        agent_conf,

        log: true,
      };
      //ອັບເດດລີດັກ
      updatelogindata(data);
      //ອັບເດດຄຸກກີ້
      Cookies.set("log", encrypt_cookie(JSON.stringify(data)), {
        expires: 1 / 12,
      });

      // Retry original request with new token
      headers.set("Authorization", `Bearer ${newToken}`);
      const retryRequest = await fetch(url, requestOptions);
      const newData = await retryRequest.json();
      return newData;
    }

    return data;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
}

async function fetchRefreshToken() {
  const { user, retoken } = store.getState().user;
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  // console.log({ user, retoken });
  const raw = JSON.stringify({
    user,
    retoken,
    // user: user,
    // retoken: retoken,
    // retoken:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NiwidXNlciI6InZ0MDAyIiwibGV2ZWwiOiJtYW5hZ2VyIiwiaWF0IjoxNzExNjgxNDY1LCJleHAiOjE3MTE3Njc4NjV9.Sjgdunp1d72Y0HSXiWKQzfJat-EF8Ibeu5cbmpnPcug",
  });

  const requestOptions = {
    method: "POST",
    headers: headers,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(ip + "users/retoken", requestOptions);
    const data = await response.json();

    // console.log({
    //   data,
    //   retoken,
    // });
    return data;
  } catch (error) {
    console.error("Error fetching refresh token:", error);
    return null;
  }
}

async function getPDFWithToken(url, dataSetForGet, token, retoken) {
  const { user, name, log, level, user_id } = store.getState().user;
  //let token =    "0eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NiwidXNlciI6InZ0MDAyIiwibGV2ZWwiOiJtYW5hZ2VyIiwiaWF0IjoxNzExNjg1NTMzLCJleHAiOjE3MTE2ODc2MzN9.ivY7aTYjmv9fBnBss-LTNjJ-JTUZu39Q0PSOKTw8yNw";
  // console.log(token);
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Authorization", `Bearer ${token}`);
  const raw = JSON.stringify(dataSetForGet);
  const requestOptions = {
    method: "POST",
    headers: headers,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(url, requestOptions);
    const data = await response.blob();

    if (response.status === 401) {
      // Token expired, get new token
      const refreshTokenResponse = await fetchRefreshToken(retoken);
      console.log(refreshTokenResponse);
      if (refreshTokenResponse.data.status !== 200) {
        console.log("ເຂົ້າສູ່ລະບົບໃໝ່ ລີໄດເລັກອອກຈາກລະບົບ");

        return null;
      }
      const newToken = refreshTokenResponse.data.token;
      console.log("ອັບເດດຂໍ້ມູນຢູ່ ລີດັກ ແລະ ຄຸກກີ້ ໃໝ່  ");
      let data = {
        user,
        name,
        log,
        level,
        user_id,
        retoken: refreshTokenResponse.data.retoken,
        token: refreshTokenResponse.data.token,
      };
      //ອັບເດດຄຸກກີ້
      Cookies.set("log", encrypt_cookie(JSON.stringify(data)), {
        expires: 1 / 12,
      });
      //ອັບເດດລີດັກ
      updatelogindata(data);

      // Retry original request with new token
      headers.set("Authorization", `Bearer ${newToken}`);
      const retryRequest = await fetch(url, requestOptions);
      const newData = await retryRequest.blob();
      return newData;
    }

    return data;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
}

export const convertToExcel = (jsonData, name) => {
  function changtime(date) {
    try {
      if (date == null) {
        throw new Error();
      }
      let a = moment(date).toDate();

      return a;
    } catch (error) {
      return null;
    }
  }
  const selectedData = jsonData.map((item) => {
    return {
      ຈຳນວນວັນຄ້າງຈ່າຍ: item.day_diff,
      ປະເພດສັນຍາ: item.policy_type,
      ລະຫັດຕົວແທນ: item.USER,
      ຊື່ຕົວແທນ: item.NAME,
      ອາກອນມູນຄ່າເພີ່ມ: item.Text116,
      ພະນັກງານຄຸ້ມຄອງຕົວແທນ: item.user_cover_name,
      ເລກທີສັນຍາ: item.policy_concat_no,
      ຊື່ລູກຄ້າ: item.o_name,
      ທີ່ຢູ່: item.o_address,
      ເບີໂທ: item.o_tel,
      ປະເພດລົດ: item.o_type,
      ຫຍີ່ຫໍ້ລົດ: item.o_make,
      ປ້າຍລົດ: item.o_plate,
      ສີລົດ: item.o_color,
      ຄວາມແຮງ: item.o_power,
      ເລກຈັກ: item.o_engine,
      ເລກຖັງ: item.o_chassis,
      ນຳໜັກ: item.o_weight,
      ຈຳນວນບ່ອນນັ່ງ: item.o_seats,
      ປະເພດນຳໃຊ້: item.a_used,
      ປະເພດອອກສັນຍາ: item.a_type,
      ວົງເງິນຄຸ້ມກັນໂຕລົດ: item.c_insured,
      ສະກຸນເງິນ: item.c_curren,
      ຄ່າທຳນຽມບຸກຄົນທີສາມ: item.a_premuim,
      ສ່ວນຫຼດບຸກຄົນທີສາມ: item.a_discount,
      ຄ່າທຳນຽມບຸກຄົນທີສາມສຸດທິ: item.a_net_premuim,
      ຮຽກຮ້ອງສິນທົດແທນ: item.h,
      ຄ່າທຳນຽມຜູ້ຂັບຂີ່: item.i,
      ຄ່າທຳນຽມໂຕລົດ: item.c_premuim,
      ສ່ວນຫຼດໂຕລົດ: item.c_discount,
      ຄ່າທຳນຽມໂຕລົດສຸດທິ: item.c_net_premuim,
      ຄ່າທຳນຽມຕົ້ນທຳອິດ: item.premuim_orginal,
      ອາກອນມູນຄ່າເພີ່ມທຳອິດ: item.vat_orginal,
      ຄ່າລົງທະບຽນທຳອິດ: item.register_orginal,
      ຄ່າທຳນຽມທັງໝົ້ດທຳອິດ: item.total_premuim_orginal,
      ຄ່າທຳນຽມຕົ້ນແກ້ໄຂ: item.premuim_edit,
      ອາກອນມູນຄ່າເພີ່ມແກ້ໄຂ: item.vat_edit,
      ຄ່າລົງທະບຽນແກ້ໄຂ: item.register_edit,
      ຄ່າທຳນຽມທັງໝົ້ແກ້ໄຂ: item.total_premuim_edit,
      ຄ່າທຳນຽມຕົ້ນປະຈຸບັນ: item.premuim,
      ຄ່າຂື້ນທະບຽນປະຈຸບັນ: item.vat,
      ຄ່າລົງທະບຽນປະຈຸບັນ: item.register,
      ຄ່າທຳນຽມທັງໝົ້ດປະຈຸບັນ: item.total_premuim,
      ວັນທີເລີ່ມຄຸ້ມກັນ: changtime(item.start),
      ວັນທີສິ້ນສຸດການຄຸ້ມກັນ: changtime(item.end),
      ການຄຸ້ມກັນ: item.cover,
      //  ຕົວແທນທີ່ສ້າງ: item.user_add,
      ວັນທີສ້າງສັນຍາການຂາຍ: changtime(item.dateadd),
      ພະນັກງານຫ້ອງການສ້າງ: item.emp_add,
      ຊື່ພະນັກງານຫ້ອງການສ້າງ: item.emp_add_name,
      "ລູກຄ້າຈ່າຍໃຫ້ຕົວແທນ 0ຍັງ 1ຈ່າຍແລ້ວ": item.emp_paid,
      "ຕົວແທນຈ່າຍໃຫ້ບໍລິສັດ 0ຍັງ 1ຈ່າຍແລ້ວ": item.paid,
      ວັນທີຕົວແທນຈ່າຍໃຫ້ບໍລິສັດ: changtime(item.paid_date),
      ລະຫັດພະນັກງານບໍລິສັດຮັບເງິນ: item.emp_get_paid,
      ຊື່ພະນັກງານບໍລິສັດຮັບເງິນ: item.emp_get_paid_name,
      ສັນຍາຍົກເລີກ0ບໍ1ຍົກເລີກ: item.cancel,
      ວັນທີຍົກເລີກ: changtime(item.cancel_date),
      ລະຫັດພະນັກງານຍົກເລີກ: item.emp_cancle,
      ຊື່ພະນັກງານຍົກເລີກ: item.emp_cancle_name,
      "ອະນຸຍາດໃຫ້ຈ່າຍຊ້າ 0ບໍ່ 1ອະນຸຍາດ": item.enable_pay_late,
      ຄ່າຄອມມິດຊັ່ນພື້ນຖານ: item.commission_percen_first,
      ຫັກຈ່າຍຊ້າ: item.paylate,
      ຄ່າຄອມມິດຊັ່ນ: item.commission_percen,
      ຄ່າຄອມມິດຊັ່ນເປັນເງິນ: item.commission_befor_diposit,
      ເສຍອາກອນລາຍໄດ້: item.commissionTax_percen,
      ເສຍອາກອນລາຍໄດ້ເປັນເງິນ: item.commissionTax,
      ເງິນຝາກຄັງຫ້ອງການ: item.diposit_percen,
      ເງິນຝາກຄັງຫ້ອງການເປັນເງິນ: item.diposit,
      ຄ່າຄອມຕົວແທນໄດ້ຮັບສຸດທິ: item.commission,
      ບໍລິສັດຈົງຈີໄດ້ຮັບ: item.zji_get,
      "ໍບໍລິສັດຈົງຈີໄດ້ຮັບຕົວຈິງ": item.zji_total_get,
      ລາຍລະອຽດ: item.detial,

      ເລກທີການຮັບເງິນ: item.recive_id,
      ເລກທີໃບບິນຮັບເງິນ: item.receive_id_bill,
      ຈຳນວນເງິນ: item.receive_money,
      ວັນທີຕົວແທນເຮັດທຸລະກຳ: changtime(item.receive_date_cust_paid),
      ວັນທີພະນັກງານເຄສເຊຍຮັບເງິນ: changtime(item.receive_date),
      ຊື່ພະນັກງານເຄສເຊຍ: item.user_name_recive,
      ຊຳລະຜ່ານທະນາຄານ: item.receive_bank_name,
    };
  });

  const ws = XLSX.utils.json_to_sheet(selectedData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  if (name == undefined) {
    XLSX.writeFile(wb, "output.xlsx");
  } else {
    XLSX.writeFile(wb, name + ".xlsx");
  }
};




export function getTextDate(_tax) {
  // const currentDate = Date.now();
  const currentDate = new Date("2024-05-01").getTime();
  const april30_2024 = new Date("2024-05-01").getTime();
  const vat = currentDate < april30_2024 ? 0.07 : 0.1;
  console.log(vat);
  return vat;
}


export function changLg(index) {
  const state = store.getState();
  const value = state.lg.value;
  // return value
  return value == 1 ? text.Sheet1[index - 1].la : text.Sheet1[index - 1].ch
}

export function changLgValue(value, index) {
  return value == 1 ? text.Sheet1[index - 1].la : text.Sheet1[index - 1].ch
}









export const processClaims = (claims) => {
  const results = claims
    .map((claim, index) => {
      if (!claim.claim_id || !claim.claim_info) {
        return null; //ຂ້າມລາຍການທີ່ບໍ່ມີຂໍ້ມູນ
      }

      let result = `${index + 1}. ເລກທີຄະດີ : ${claim.claim_id}\n`;
      result += `  ${index + 1}.1 ລາຍລະອຽດ : ${claim.claim_info}\n`;

      try {
        const payments = JSON.parse(claim.payment_orders);
        payments.forEach((payment, idx) => {
          if (payment.payment_type_name && payment.pay_order_amount) {
            result += `  ${index + 1}.${idx + 2} ${payment.payment_type_name} : ${ formatFloatNumber(payment?.pay_order_amount)}\n`;
          }
        });
      } catch (error) {
        console.error("Error parsing payment_orders:", error);
      }

      return result.trim();
    })
    .filter(Boolean) // ลบ `null` ออกจาก array
    .join("\n => \n");

  return results || " "; // ຖ້າບໍ່ມີຂໍ້ມູນໃຫ້ສະແດງຄ່າວ່າ
};


export const convertToExcelEnd = (jsonData, name) => {
  const selectedData = jsonData.map((item) => {
    return {
      ປະເພດການອອກສັນຍາ: item.type,
      ລະຫັດຕົວແທນ: item.USER,
      ເລກທີສັນຍາ: item.policy_concat_no,
      ຊື່ລູກຄ້າ: item.o_name,
      ທີ່ຢູ່: item.o_address,
      ເບີໂທ: item.o_tel,
      ປະເພດລົດ: item.o_type,
      ຫຍີ່ຫໍ້ລົດ: item.o_make,
      ປ້າຍລົດ: item.o_plate,
      ສີລົດ: item.o_color,
      ຄວາມແຮງ: item.o_power,
      ເລກຈັກ: item.o_engine,
      ເລກຖັງ: item.o_chassis,
      ນຳໜັກ: item.o_weight,
      ຈຳນວນບ່ອນນັ່ງ: item.o_seats,
      ຄ່າທຳນຽມຕົ້ນປະຈຸບັນ: item.premuim,
      ຄ່າຂື້ນທະບຽນປະຈຸບັນ: item.vat,
      ຄ່າລົງທະບຽນປະຈຸບັນ: item.register,
      ຄ່າທຳນຽມທັງໝົ້ດປະຈຸບັນ: item.total_premuim,
      ວັນທີເລີ່ມຄຸ້ມກັນ: moment(item.start).toDate(),
      ວັນທີສິ້ນສຸດການຄຸ້ມກັນ: moment(item.end).toDate(),
      ການຄຸ້ມກັນ: item.cover,
      ການເກີດອຸປະຕິເຫດ: processClaims(item.claim || []),

    };
  });

  const ws = XLSX.utils.json_to_sheet(selectedData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  if (name == undefined) {
    XLSX.writeFile(wb, "output.xlsx");
  } else {
    XLSX.writeFile(wb, name + ".xlsx");
  }
};




export function showPolicyEnd(data) {
  const groupedData = Object.values(
    data.reduce((acc, item) => {
      const key = item.policy_concat_no;

      if (!acc[key]) {
        acc[key] = {
          type: item.type,
          USER: item.USER,
          policy_concat_no: item.policy_concat_no,
          o_name: item.o_name,
          o_address: item.o_address,
          o_tel: item.o_tel,
          o_type: item.o_type,
          o_make: item.o_make,
          o_plate: item.o_plate,
          o_color: item.o_color,
          o_power: item.o_power,
          o_engine: item.o_engine,
          o_chassis: item.o_chassis,
          o_weight: item.o_weight,
          o_seats: item.o_seats,
          premuim: item.premuim,
          vat: item.vat,
          register: item.register,
          total_premuim: item.total_premuim,
          start: item.start,
          end: item.end,          
          cover: item.cover,
          claim: []
        };
      }

      // เพิ่มข้อมูลเคลมเข้าไปใน array claim
      acc[key].claim.push({
        claim_id: item.claim_id,
        claim_info: item.claim_info,
        claim_address: item.claim_address,
        where_table: item.where_table,
        policy_no: item.policy_no,
        payment_orders: item.payment_orders
      });

      return acc;
    }, {})
  );
  return groupedData
}